import { render, staticRenderFns } from "./DetalhesAnexosEvento.vue?vue&type=template&id=a3b07982"
import script from "./DetalhesAnexosEvento.vue?vue&type=script&lang=ts"
export * from "./DetalhesAnexosEvento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports